module.exports = __webpack_public_path__ + "static/media/icon_license.645e48cb.png";